import {Subject} from 'rxjs';
import {filter} from 'rxjs/operators';

export interface WsEvent {
  type: string;
  data: any
}

// TODO: test reconnect
export default class WebSocketObservable extends Subject<WsEvent> {
  private ws: WebSocket;
  private reconnectTimeout: any;

  constructor(private url: string) {
    super();

    this.connect(url);
  }

  get connected() {
    return this.ws;
  }

  public send(type, data = {}) {
    if (!this.ws || this.ws.readyState != 1) return false;

    try {
      this.ws.send(JSON.stringify({type: type, data: data}));
    } catch (e) {
      console.log(e.toString());
    }
  }

  public on(type: string) {
    return this.pipe(filter(event => event.type === type));
  }

  destroy() {
    this.ws.onclose = null;
    this.ws.close();
    this.ws = null;
  }

  reconnect() {
    this.onClose();
  }

  private connect(url: string) {
    this.restartTimer();

    this.ws = new WebSocket(url);
    this.ws.addEventListener('message', event => this.onMessage(event));
    this.ws.onclose = () => this.onClose();
  }

  private restartTimer() {
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
    }
    this.reconnectTimeout = setTimeout(() => this.onClose(), 30000);
  }

  private onMessage(event) {
    this.restartTimer();

    try {
      let msg = JSON.parse(event.data);
      this.next({type: msg.type, data: msg.data});
    } catch (err) {
      return;
    }
  }

  private onClose() {
    if (this.ws) {
      this.destroy();
    }

    this.connect(this.url);
  }
}
